// モーダル管理
import { imageTransforms, updateImageTransforms, setAlbumPreviewBackupTransforms, albumPreviewBackupTransforms, clearEditingState } from "./state.js";
import { saveAllTransformsToHiddenInputs } from "./imageTransforms.js";

// プレビューモーダルを表示
export const showPreviewModal = (previewModal) => {
  if (previewModal) {
    previewModal.style.display = "flex";
  }
};

// プレビューモーダルを非表示
export const hidePreviewModal = (previewModal, popupCtx, popupCanvas) => {
  if (previewModal) {
    previewModal.style.display = "none";
    if (popupCtx) {
      popupCtx.clearRect(0, 0, popupCanvas.width, popupCanvas.height);
    }
    previewModal.removeAttribute("data-editing-image-index");

    // 編集状態をクリア
    clearEditingState();
    console.log(`[hidePreviewModal] 編集状態をクリアしました`);

    // 警告メッセージをクリア
    const warningMsg = document.getElementById("coverFitWarning");
    if (warningMsg) {
      warningMsg.remove();
    }
    const moveWarningMsg = document.getElementById("moveBlockedWarning");
    if (moveWarningMsg) {
      moveWarningMsg.remove();
    }
  }
};

// アルバムプレビューモーダルを表示
export const showAlbumPreviewModal = (albumPreviewModal, drawMainAlbumCanvasCallback) => {
  // モーダル開始時の状態をバックアップ（ディープコピー）
  setAlbumPreviewBackupTransforms(imageTransforms);
  console.log("[showAlbumPreviewModal] 変換情報をバックアップしました:", JSON.stringify(albumPreviewBackupTransforms));

  // メインプレビューを描画
  if (drawMainAlbumCanvasCallback) {
    drawMainAlbumCanvasCallback();
  }

  // メインプレビューモーダルを表示
  if (albumPreviewModal) {
    albumPreviewModal.style.display = "flex";
  }
};

// アルバムプレビューモーダルを非表示（キャンセル処理）
export const hideAlbumPreviewModal = (albumPreviewModal, drawMainAlbumCanvasCallback) => {
  console.log("[hideAlbumPreviewModal] モーダルを閉じます（キャンセル扱い）");

  // バックアップから変換情報を復元
  if (albumPreviewBackupTransforms) {
    updateImageTransforms(albumPreviewBackupTransforms);
    console.log("[hideAlbumPreviewModal] 変換情報を復元しました:", JSON.stringify(imageTransforms));

    // メインプレビューを再描画（復元された状態で）
    if (drawMainAlbumCanvasCallback) {
      drawMainAlbumCanvasCallback();
    }
  }

  // バックアップをクリア
  setAlbumPreviewBackupTransforms(null);

  if (albumPreviewModal) {
    albumPreviewModal.style.display = "none";
  }
};

// アルバムプレビューモーダルの保存処理
export const saveAlbumPreviewChanges = (albumPreviewModal) => {
  console.log("[saveAlbumPreviewChanges] 変更を保存して完了します");

  // 現在の変換情報をhidden inputに保存
  saveAllTransformsToHiddenInputs();

  // バックアップをクリア
  setAlbumPreviewBackupTransforms(null);

  // モーダルを閉じる
  if (albumPreviewModal) {
    albumPreviewModal.style.display = "none";
  }

  alert("変更が保存されました。");
};
